import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User } from "../../types/users";
import { buildApiConfig } from "../../api/client";
import { ResponseError } from "../../types/errors";
import axios from "axios";

type DataStatus = "notInitiated" | "inProgress" | "completed";

export type UserState = {
  data?: User;
  accessToken?: string;
  dataStatus: DataStatus;
};

const initialState: UserState = {
  data: null,
  accessToken: null,
  dataStatus: "notInitiated",
};

export const userSlice = createSlice({
  name: "userSlice",
  initialState: initialState,
  reducers: {
    setFetchingStatus: (
      state: UserState,
      action: PayloadAction<DataStatus>
    ) => {
      state.dataStatus = action.payload;
    },
    setAccessToken: (state: UserState, action: PayloadAction<string>) => {
      state.accessToken = action.payload;
      state.dataStatus = "notInitiated";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchMeThunk.fulfilled,
      (state: UserState, action: PayloadAction<User>) => {
        state.data = action.payload;
      }
    );
  },
});

export const fetchMeThunk = createAsyncThunk("fetchMe", async (_, thunkAPI) => {
  thunkAPI.dispatch(userSlice.actions.setFetchingStatus("inProgress"));
  const accessToken = (thunkAPI.getState() as UserState).accessToken;
  return axios
    .get<User>("/me", buildApiConfig("users", accessToken))
    .then((response) => {
      thunkAPI.dispatch(userSlice.actions.setFetchingStatus("completed"));
      return response.data;
    })
    .catch((reason) => {
      thunkAPI.dispatch(userSlice.actions.setFetchingStatus("completed"));
      throw new ResponseError(reason);
    });
});
